import * as React from "react";
import { Product } from "@grandvisionhq/analytics";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
import { getPriceSpecificationConfig } from "../../../../utils/modules/Analytics/utils/get-price-specification-config.js";
const ProductStructuredData = () => {
  const { activeVariant, displayPrice, product, productUrl } = useProductData();
  const { analyticsData, brandName, name } = product;
  const { category, ratingsSummary, vatRate } = analyticsData;
  const {
    description,
    seoConfig,
    sku,
    media: { images }
  } = activeVariant;
  const priceSpecification = getPriceSpecificationConfig({
    displayPrice,
    vat: vatRate
  });
  const img = images[0] ? images[0].url : seoConfig.ogImageUrl;
  return /* @__PURE__ */ React.createElement(
    Product,
    {
      name: name || seoConfig.metaTitle,
      image: img,
      description,
      brand: brandName,
      category,
      sku,
      url: productUrl,
      ratingsSummary,
      priceSpecificationConfig: priceSpecification,
      isCentAmount: false
    }
  );
};
export {
  ProductStructuredData
};
//# sourceMappingURL=ProductStructuredData.js.map
